<template lang="pug">
div
  new-process
  liondesk-dialog(
      width="600px"
      v-model="confirmLeaveModal_isVisible"
      dialog-title="IMPORT CONTACTS"
      ok-button-text="YES"
      cancel-button-text="NO"
      @click:cancel="confirmLeaveModal_cancel"
      @click:ok="confirmLeaveModal_confirm"
  )
    template(slot="body")
      v-container.px-0
        v-layout(row wrap)
          v-flex(xs12)
            span Leaving this page will clear your uploaded file, Are you sure?
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

import NewProcess from '@/Contacts/components/import/NewProcess';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import ConfirmLeaveModal from '@/Core/mixins/confirmLeaveModal';

const {
  mapActions: mapImportFileActions,
  mapState: mapImportFileState,
  mapMutations: mapImportFileMutations,
} = createNamespacedHelpers('importFile');

export default {
  name: 'ImportContacts',
  components: {
    NewProcess,
    LiondeskDialog,
  },
  mixins: [ConfirmLeaveModal],
  methods: {
    ...mapImportFileMutations(['clearMessages']),
    ...mapImportFileActions(['deleteImportFile']),
  },
  computed: {
    ...mapImportFileState(['loading', 'hasError', 'error', 'uploadedFile']),
    ...mapImportFileState({ importFileData: 'data' }),
  },
  beforeRouteLeave(to, from, next) {
    if (!this.importFileData || !this.uploadedFile) {
      next();
      return;
    }

    if (to.name === 'contact-import-reporting' && to.query['new-import']) {
      next();
      return;
    }

    this.confirmLeaveModal_open(async () => {
      await this.deleteImportFile(this.importFileData.file_id);
      this.clearMessages();
      next();
    });
  },
};
</script>